import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/Sidebar.css";
import { FaCog } from "react-icons/fa";
import { FaChartLine } from "react-icons/fa6";
import { GiSettingsKnobs } from "react-icons/gi";
import logo from "../assets/spashscreenLogo.png";
import { LuChevronRight } from "react-icons/lu";
import { PiAddressBookTabs } from "react-icons/pi";
import { FaRegCalendarAlt } from "react-icons/fa";
import { TbTreadmill } from "react-icons/tb";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { FaUserNinja } from "react-icons/fa";
import { MdOutlineNoteAlt } from "react-icons/md";
import { IoIosNotifications } from "react-icons/io";
import { RiImageAddLine } from "react-icons/ri";
import { useAdmin } from "../contexts/AdminContext";
import { FiFileText } from "react-icons/fi";

const Sidebar = () => {
  const { admin } = useAdmin();
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      name: "Overview",
      path: "/admin/overview",
      icon: <FaChartLine />,
      key: "overview",
    },
    {
      name: "User Management",
      path: "/admin/usermanagement",
      icon: <GiSettingsKnobs />,
      key: "userManagement",
    },
    {
      name: "Membership Management",
      path: "/admin/membershipmanagement",
      icon: <PiAddressBookTabs />,
      key: "membershipManagement",
    },
    {
      name: "Diet Plan Management",
      path: "/admin/dietplanmanagement",
      icon: <FaRegCalendarAlt />,
      key: "dietPlanManagement",
    },
    {
      name: "Exercise Management",
      path: "/admin/exercisemanagement",
      icon: <TbTreadmill />,
      key: "exerciseManagement",
    },
    {
      name: "GST Invoice and Agreement",
      path: "/admin/gstinvoicemanagement",
      icon: <LiaFileInvoiceDollarSolid />,
      key: "gstInvoiceAndAgreement",
    },
    {
      name: "Trainer Management",
      path: "/admin/trainermanagement",
      icon: <FaUserNinja />,
      key: "trainerManagement",
    },
    {
      name: "Booking Management",
      path: "/admin/bookingmanagement",
      icon: <MdOutlineNoteAlt />,
      key: "bookingManagement",
    },
    {
      name: "Post Management",
      path: "/admin/postmanagement",
      icon: <RiImageAddLine />,
      key: "postManagement",
    },
    {
      name: "Notification Management",
      path: "/admin/notificationmanagement",
      icon: <IoIosNotifications />,
      key: "notificationManagement",
    },
    {
      name: "Terms & Conditions",
      path: "/admin/termsandconditions",
      icon: <FiFileText />,
      key: "termsandconditions",
    },
    {
      name: "Settings & Admin Controls",
      path: "/admin/settings",
      icon: <FaCog />,
      key: "settingsAndAdminControls",
    },
  ];

  // Filter menu items based on permissions
  const filteredMenuItems = admin.isSuperAdmin
    ? menuItems
    : menuItems.filter((item) => admin.permissions?.[item.key]);

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div className="sidebarContainer">
      <div className="sidebarImageContainer">
        <img src={logo} alt="logo" />
      </div>
      <ul className="sidebarUl">
        {filteredMenuItems.map((item) => (
          <li
            key={item.name}
            onClick={() => handleNavigation(item.path)}
            className={location.pathname === item.path ? "active" : ""}
            style={{ position: "relative" }}
          >
            {item.icon}
            <span style={{ fontSize: 17 }}>{item.name}</span>
            <LuChevronRight />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
